import { render, staticRenderFns } from "./ScreenShare.vue?vue&type=template&id=2916c573&"
import script from "./ScreenShare.vue?vue&type=script&lang=js&"
export * from "./ScreenShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports